import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/common.css";
import { EyeFilled } from "@ant-design/icons";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate, formatDateTime } from "../../../utils/dateFormatter";

const ListenginelogBooks = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [ship_id, set_ship_id] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_ENGINE_LOGBOOK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_ENGINE_LOGBOOK_API = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.listing_engine_logbook_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
          localStorage.setItem("ship_id", ship_id);
          set_page_loader(false);
        } else {
          ErrorToast("Error message", res?.errors);
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "eng_log_basic_id",
      align: "center",
      key: "eng_log_basic_id",
      sorter: (a, b) => a.eng_log_basic_id - b.eng_log_basic_id,
    },
    {
      title: "Basic Log status",
      dataIndex: "eng_log_basic",
      align: "center",
      key: "eng_log_basic",
      render: (text, record) => {
        if (record.eng_log_basic === "Completed") {
          return <span className="table-status-activate">{record?.eng_log_basic}</span>;
        } else {
          return <span className="table-status-deactivate">{record?.eng_log_basic}</span>;
        }
      },
    },
    {
      title: "Main Engine Log status",
      dataIndex: "main_eng_log",
      align: "center",
      key: "main_eng_log",
      render: (text, record) => {
        if (record?.main_eng_log === "Completed") {
          return <span className="table-status-activate">{record?.main_eng_log}</span>;
        } else {
          return <span className="table-status-deactivate">{record?.main_eng_log}</span>;
        }
      },
    },
    {
      title: "Auxiliary Engine Log status",
      dataIndex: "aux_eng_log",
      align: "center",
      key: "aux_eng_log",
      render: (text, record) => {
        if (record?.aux_eng_log === "Completed") {
          return <span className="table-status-activate">{record?.aux_eng_log}</span>;
        } else {
          return <span className="table-status-deactivate">{record?.aux_eng_log}</span>;
        }
      },
    },
    {
      title: "Auxiliary Machinary Log status",
      dataIndex: "auxi_machinery_log",
      align: "center",
      key: "auxi_machinery_log",
      render: (text, record) => {
        if (record?.auxi_machinery_log === "Completed") {
          return <span className="table-status-activate">{record?.auxi_machinery_log}</span>;
        } else {
          return <span className="table-status-deactivate">{record?.auxi_machinery_log}</span>;
        }
      },
    },
    {
      title: "Cargo Machinary Log status",
      dataIndex: "cargo_machinery_log",
      align: "center",
      key: "cargo_machinery_log",
      render: (text, record) => {
        if (record?.cargo_machinery_log === "Completed") {
          return <span className="table-status-activate">{record?.cargo_machinery_log}</span>;
        } else {
          return <span className="table-status-deactivate">{record?.cargo_machinery_log}</span>;
        }
      },
    },
    {
      title: "Created For",
      dataIndex: "date_time_log",
      key: "date_time_log",
      align: "center",
      render: (_, record) => formatDateTime(record.date_time_log),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <Tooltip title="View">
            <Button
              type="primary"
              size="small"
              onClick={() => navigate(`/view-engine-basic-info/${record?.eng_log_basic_id}`)}
              style={{ marginRight: "5px" }}
              icon={<EyeFilled />}
            />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <div className="row">
          <div className="col-3">
            <label className="block-label">Select Ship</label>
            <Select
              placeholder="---- Select Ship ----"
              style={{ width: "100%" }}
              value={ship_id}
              onChange={(value) => {
                set_ship_id(value);
                LIST_ENGINE_LOGBOOK_API(value);
              }}
            >
              {ship_table_list?.length > 0 && (
                <>
                  {ship_table_list.map((ship) => (
                    <>
                      {!ship.soft_delete && (
                        <>
                          <Select.Option key={ship.id} value={ship.id}>
                            {ship.vessel_name}
                          </Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
          </div>
        </div>

        <div className="row" style={{ padding: "10px" }}>
          <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
            <div className="theme-content-title text-left">
              <h3>Engine Logbook Information</h3>
            </div>
          </div>
          <div className="col-3"></div>
          <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="d-flex align-items-center">
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/view-audit-trail-engine-log")}
              >
                Audit Trail
              </Button>
            </div>
          </div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default ListenginelogBooks;
